exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-addon-custom {\n  /* padding: 0.85rem 1rem; */\n  margin-bottom: 0;\n  font-size: .7rem;\n  font-weight: normal;\n  line-height: 1.25;\n  color: #607d8b;\n  text-align: center;\n  background-color: #cfd8dc;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/account/signin/signin.component.scss
// module id = ../../../../../src/app/account/signin/signin.component.scss
// module chunks = 6